var MpPageAdvertising;

(function() {
    if (!document.querySelector('#vue-advertising')) {
        return;
    }

    MpPageAdvertising = new Vue({
        el: '#vue-advertising',
        mixins: [MpStaticPage],
    });

})();
